<div
  class="thumbnail"
  [class.constrain]="constrainWidth"
  [class.vertical]="isVertical"
  alt=""
  [style.aspect-ratio]="
    thumbnailInfo
      ? thumbnailInfo.width + '/' + thumbnailInfo.height
      : assetVersion.data.width + '/' + assetVersion.data.height
  "
  #el
>
  @if (thumbnailInfo) {
    <img
      [src]="thumbnailInfo.url"
      alt=""
      [attr.data-picflow-hide]="true"
      [style.width]="thumbnailInfo.xTiles + '00%'"
      [style.top]="-thumbnailInfo.y * 100 + '%'"
      [style.left]="-thumbnailInfo.x * 100 + '%'"
    />
  }
  @if (!thumbnailInfo) {
    <img
      [src]="
        assetVersion
          | assetVersionUrl
            : assetVersion.uuid
            : assetVersion.status
            : assetVersion.watermark_uuid
            : el.clientWidth
            : true
            : false
      "
      alt=""
      [attr.data-picflow-hide]="true"
    />
  }
  @if (showTime) {
    <div class="time">
      {{ currentTime / 60 | floor | number: '2.0-0' }}:{{ currentTime % 60 | floor | number: '2.0-0' }}
    </div>
  }
</div>
